import { useEffect, useRef, useState } from 'react';
import { Container, Message } from './styles';

type NotificationTextProps = {
  data: {
    message: string;
    type?: 'success' | 'error' | 'info';
  };
};

const NotificationText = ({ data: { message, type = 'info' } }: NotificationTextProps) => {
  const [display, setDisplay] = useState({ message, type });
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Keeps the message data for the fade out duration (otherwise message disappears immediately)
  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (message) {
      setDisplay({ message, type });
    } else {
      timeoutRef.current = setTimeout(() => {
        setDisplay({ message: '', type: 'info' });
      }, 1000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [message, type]);

  return (
    <Container $hidden={!message}>
      <Message $type={display.type}>{display.message}</Message>
    </Container>
  );
};

export default NotificationText;
